import { computed } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { useFileStore } from '../store/file/file';
import useUserComposable from './UserComposable';

const useFileComposable = () => {
    const store = useStore();
    const { loggedUser } = useUserComposable();
    const company_id = computed(() => {
        return store.getters['auth/userCompanyId']?.id;
    });

    const { file, images } = storeToRefs(useFileStore());
    const { uploadFile, getUploadedImages } = useFileStore();

    const fileUploader = async (files) => {
        return await uploadFile('/v2/upload?company_id=' + company_id.value, files);
    };

    const fetchImages = async (userFlag) => {
        return await getUploadedImages(userFlag ? loggedUser.value?.id : null, company_id.value);
    };

    return {
        file,
        images,
        fileUploader,
        fetchImages,
    };
};

export default useFileComposable;
